"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFilePdf = function IconFilePdf(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M18 2v7h4v8h-4v1c0 2.2-1.8 4-4 4H2V2zm-4 18c1.1 0 2-.9 2-2v-1H6V9h10V4H4v16zm-4.74-4.7v-1.603h.805c1.043 0 1.673-.539 1.673-1.47 0-.938-.63-1.477-1.673-1.477H8.56v4.55zm.798-2.261H9.26v-1.631h.798c.63 0 .959.308.959.819s-.329.812-.959.812m6.017-.014c0 1.302-.833 2.275-2.282 2.275h-1.358v-4.55h1.358c1.449 0 2.282.966 2.282 2.275M13.8 14.649h-.672v-3.248h.672c.945 0 1.554.651 1.554 1.624s-.602 1.624-1.554 1.624m3.741-1.337V15.3h-.7v-4.55h2.737v.658h-2.037v1.267h1.897v.637z",
    clipRule: "evenodd"
  })));
};

export { IconFilePdf, IconFilePdf as default };
